import { render, staticRenderFns } from "./addBranches.vue?vue&type=template&id=282336fa&scoped=true"
import script from "./addBranches.vue?vue&type=script&lang=js"
export * from "./addBranches.vue?vue&type=script&lang=js"
import style0 from "./addBranches.vue?vue&type=style&index=0&id=282336fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282336fa",
  null
  
)

export default component.exports